import api from './Axios';

/**
 * Announcements API
 * Base: /api/announcements
 */

export const getAnnouncements = () =>
  api.get('/announcements');

export const getAnnouncementById = (announcementId) =>
  api.get(`/announcements/${announcementId}`);

export const createAnnouncement = (data) =>
  api.post('/announcements', data);

export const updateAnnouncement = (announcementId, data) =>
  api.put(`/announcements/${announcementId}`, data);

export const deleteAnnouncement = (announcementId) =>
  api.delete(`/announcements/${announcementId}`);